import React, { useState, useEffect } from 'react';
import DOLayout from '../../components/directOrders/DOLayout';
import OrdersExplorer from '../../components/directOrders/OrdersExplorer';
import DirectOrderViewModal from '../../components/DirectOrderViewModal';
import { useDirectOrder } from '../../context/DirectOrderContext';

const CCOrdersPage = () => {
  const { loadCCDirectOrders, ccDirectOrders, loading } = useDirectOrder();
  const [selectedDirectOrder, setSelectedDirectOrder] = useState(null);

  useEffect(() => {
    loadCCDirectOrders();
  }, [loadCCDirectOrders]);

  return (
    <DOLayout
      title="CC'd to me"
      subtitle="Direct orders raised by colleagues who copied you in. These are read-only."
    >
      <OrdersExplorer
        orders={Array.isArray(ccDirectOrders) ? ccDirectOrders : []}
        loading={loading}
        showSubmitter
        onOpen={setSelectedDirectOrder}
        emptyTitle="Nothing copied to you"
        emptyHint="When someone adds you as the CC on a direct order, it will show up here."
      />

      {selectedDirectOrder && (
        <DirectOrderViewModal visible directOrder={selectedDirectOrder} onClose={() => setSelectedDirectOrder(null)} />
      )}
    </DOLayout>
  );
};

export default CCOrdersPage;
